import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CaseStudiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="relative overflow-hidden bg-white grid-bg pt-36 pb-20">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(13,148,136,0.14), transparent 58%), radial-gradient(ellipse at 85% 20%, rgba(249,115,22,0.10), transparent 55%)' }}
        ></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
            <div className="eyebrow">Proof</div>
            <h1 className="mt-6 h-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
              Case Studies
            </h1>
            <p className="mt-6 text-lg md:text-xl text-slate-600 font-body font-light max-w-2xl">
              Real results from Florida businesses winning with AI marketing.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-navy-50 rounded-2xl p-12 border-2 border-navy-100 mb-12">
              <div className="text-center mb-8">
                <div className="inline-flex items-center space-x-2 px-4 py-2 bg-teal-500 text-navy-900 rounded-full mb-4">
                  <i className="ri-trophy-line"></i>
                  <span className="text-sm font-semibold">Self Case Study</span>
                </div>
                <h2 className="text-3xl font-display font-bold text-navy-900 mb-4">
                  How We Built Florida AI Marketing Experts
                </h2>
                <p className="text-navy-600 text-sm">
                  Practicing what we preach: Our own AI marketing journey
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white rounded-xl p-6 text-center border-2 border-navy-100">
                  <div className="text-3xl font-bold text-teal-600 mb-2">100%</div>
                  <p className="text-sm text-navy-600">AI Visibility in 60 Days</p>
                </div>
                <div className="bg-white rounded-xl p-6 text-center border-2 border-navy-100">
                  <div className="text-3xl font-bold text-teal-600 mb-2">24/7</div>
                  <p className="text-sm text-navy-600">Voice AI Lead Response</p>
                </div>
                <div className="bg-white rounded-xl p-6 text-center border-2 border-navy-100">
                  <div className="text-3xl font-bold text-teal-600 mb-2">Ready</div>
                  <p className="text-sm text-navy-600">For ChatGPT Ads Launch</p>
                </div>
              </div>

              <div className="space-y-4 text-sm">
                <div>
                  <h3 className="font-bold text-navy-900 mb-2">The Challenge:</h3>
                  <p className="text-navy-600 leading-relaxed">
                    Launch a new AI marketing agency in a crowded Florida market where most businesses don't yet understand AI marketing. Need to establish authority and generate qualified leads quickly.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-navy-900 mb-2">Our Approach:</h3>
                  <ul className="space-y-2">
                    <li className="flex items-start space-x-2">
                      <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Built comprehensive GEO content targeting "AI marketing Florida" queries</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Deployed voice AI agent to handle inbound inquiries 24/7</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Prepared ChatGPT ads readiness for when platform launches</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Created free AI Assessment offer to generate qualified leads</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="font-bold text-navy-900 mb-2">Results:</h3>
                  <ul className="space-y-2">
                    <li className="flex items-start space-x-2">
                      <i className="ri-star-fill text-yellow-500 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">AI platforms now recognize and recommend us for Florida AI marketing queries</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-star-fill text-yellow-500 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Voice AI agent handles 100% of after-hours inquiries with instant response</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-star-fill text-yellow-500 mt-0.5 flex-shrink-0"></i>
                      <span className="text-navy-600">Positioned as early mover when ChatGPT ads become available</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-navy-50 rounded-2xl p-12 border-2 border-navy-100 text-center">
              <div className="mb-6">
                <i className="ri-time-line text-orange-400 text-5xl mb-4"></i>
              </div>
              <h2 className="text-3xl font-display font-bold text-navy-900 mb-4">
                Client Case Studies Coming Soon
              </h2>
              <p className="text-base text-navy-600 mb-8 max-w-2xl mx-auto leading-relaxed">
                We're currently working with Florida home services, professional services, and real estate businesses. Detailed case studies with results will be published as campaigns mature.
              </p>
              <p className="text-navy-600 mb-8 text-sm">
                <strong>Want to be featured?</strong> Join our early adopter program and help us prove the power of AI marketing.
              </p>
              <Link
                to="/contact"
                className="btn-primary inline-flex items-center px-8 py-4 whitespace-nowrap cursor-pointer"
              >
                Become a Case Study
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            <div className="mt-12 bg-white border-2 border-navy-100 rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-display font-bold text-navy-900 mb-4">
                Client Testimonials
              </h3>
              <p className="text-navy-600 text-sm leading-relaxed">
                Case studies coming as we publish client wins.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-navy-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-display font-bold text-navy-900 mb-6">
            Ready to Write Your Success Story?
          </h2>
          <p className="text-base text-navy-600 mb-8">
            Start with a free AI Assessment and see where you stand
          </p>
          <Link
            to="/audit"
            className="btn-primary inline-flex items-center px-8 py-4 whitespace-nowrap cursor-pointer"
          >
            Get Free AI Assessment
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
